// extracted by mini-css-extract-plugin
export default {"wrapper":"TwoColSection_wrapper__CqifC","right":"TwoColSection_right__T-WGS"};